import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { CrudBaseService } from '../crud.service';
import { InternalBroker } from '../models';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { HttpHelper } from 'eightcap-core/helpers';

@Injectable()
export class AgentService extends CrudBaseService<InternalBroker.Agent> {
    constructor(protected httpClient: HttpClient) {
        super('/agent', httpClient);
    }

    link(agentId: string, tradingAccountIds: Array<string>): Observable<any> {
        return this.httpClient.patch(this.basePath + '/' + agentId, {
            data: {
                targets_linked: tradingAccountIds.map((id) => ({ id }))
            }
        });
    }

    unlink(agentId: string, tradingAccountIds: Array<string>): Observable<any> {
        return this.httpClient.patch(this.basePath + '/' + agentId, {
            data: {
                targets_unlink: tradingAccountIds.map((id) => ({ id }))
            }
        });
    }
}

@Injectable()
export class AgentAdminService extends AgentService {
    constructor(protected override httpClient: HttpClient) {
        super(httpClient);
    }

    override filter(filterParams: any): Observable<InternalBroker.Agent[]> {
        return this.httpClient
            .get<InternalBroker.Agent[]>(this.basePath + '/ListReferrals', {
                params: HttpHelper.objectToHttpParams({ ...filterParams })
            })
            .pipe(map((res: any) => res && res.data));
    }

    filterReferrals(agentId: string): Observable<InternalBroker.AgentReferrals[]> {
        return this.httpClient
            .get<InternalBroker.AgentReferrals[]>(this.basePath + '/getreferrals/' + agentId)
            .pipe(map((res: any) => res && res.data));
    }
}
